import { render, staticRenderFns } from "./add_vttk.vue?vue&type=template&id=607531be&scoped=true"
import script from "./add_vttk.vue?vue&type=script&lang=js"
export * from "./add_vttk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607531be",
  null
  
)

export default component.exports